import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { distinctUntilChanged } from 'rxjs';

import { EnvironmentService, UaService } from '@ecm/consumer';
import { RouterService } from '@ecm/router';
import { TMSService } from '@ecm/tracker';

import { SmartbannerStoreService } from '../../store/smartbanner-store.service';
import { SmartbannerTmsKey } from './smartbanner-tms-key';

const faviconPathOrangeEtMoi = '/assets/images/favicon/oem_fr.svg';
const faviconPathMySosh = '/assets/images/favicon/mysosh_fr.svg';

@Component({
    selector: 'ecm-smartbanner',
    templateUrl: './smartbanner.component.html',
    styleUrls: ['./smartbanner.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslateModule],
})
export class SmartbannerComponent implements OnInit {
    protected routerService = inject(RouterService);
    protected uaService = inject(UaService);
    private readonly environmentService = inject(EnvironmentService);
    private readonly smartBannerStore = inject(SmartbannerStoreService);
    private readonly tmsService = inject(TMSService);
    private readonly cdr = inject(ChangeDetectorRef);
    private readonly destroyRef = inject(DestroyRef);

    public smartBannerBrand: string | undefined;
    public smartBannerImg: string | undefined;
    public smartBannerUrl = '';

    private trackZone = '';

    private hasTrackedView = false;

    public ngOnInit(): void {
        /* UC we need to detect the brand to display smartbanner in correct ui - reactive to brand changes */
        this.routerService.isSosh$
            .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
            .subscribe((isSosh) => {
                this.smartBannerBrand = isSosh ? 'My Sosh' : 'Orange et moi';
                this.smartBannerImg = isSosh ? faviconPathMySosh : faviconPathOrangeEtMoi;
                this.smartBannerUrl = this.environmentService.instant(
                    `API.SMARTBANNER.URL_${isSosh ? 'SOSH' : 'OEM'}_${
                        this.uaService.getOSName() === 'iOS' ? 'IOS' : 'ANDROID'
                    }`,
                );
                this.trackZone = isSosh ? 'smart_banner_mysosh' : 'smart_banner_orangeetmoi';
                if (!this.hasTrackedView) {
                    this.hasTrackedView = true;
                    const data: any = {
                        track_zone: this.trackZone,
                        track_nom: SmartbannerTmsKey.VW_SMARTBANNER,
                        track_cible: SmartbannerTmsKey.VW_SMARTBANNER,
                        flag_acte: 'true',
                        id_tracking: isSosh ? 'RMReEPbH' : 'tcONY3kp',
                    };
                    this.tmsService.trackView(data);
                }
                this.cdr.markForCheck();
            });
    }

    public close(): void {
        const data: any = {
            track_zone: this.trackZone,
            track_nom: SmartbannerTmsKey.LK_SMARTBANNER_CLOSED,
            track_cible: '/'.concat(SmartbannerTmsKey.LK_SMARTBANNER_CLOSED),
        };
        this.tmsService.trackLink(data);
        this.smartBannerStore.close();
    }

    public navigateToApp(): void {
        const data: any = {
            track_zone: this.trackZone,
            track_nom: SmartbannerTmsKey.LK_SMARTBANNER_OPEN,
            track_cible: '/'.concat(SmartbannerTmsKey.LK_SMARTBANNER_OPEN),
        };
        this.tmsService.trackLink(data);
        this.smartBannerStore.navigateToApp(this.smartBannerUrl);
    }
}
